// utils/auth.js (optional)
export const saveAuthToSession = (data) => {
  if (!data) return;

  const {
    accessToken,
    refreshToken,
    expiresIn,
    roles,
    tokenType,
    userId,
    userName,
    emailId,
    phoneNumber,
    profilePicture,
    branchId,
    branchName,
    branches,
    gradeAccess,
    permissions,
  } = data;

  // tokens
  sessionStorage.setItem("accessToken", accessToken || "");
  sessionStorage.setItem("refreshToken", refreshToken || "");
  sessionStorage.setItem("tokenType", tokenType || "Bearer");

  // compute absolute expiry timestamp (ms since epoch)
  const expiresAt = expiresIn ? Date.now() + expiresIn * 1000 : null;
  if (expiresAt) sessionStorage.setItem("expiresAt", String(expiresAt));

  // role handling (first role if array)
  let roleValue = "";
  if (Array.isArray(roles)) {
    roleValue = roles.length > 0 ? roles[0] : "";
  } else if (typeof roles === "string") {
    roleValue = roles;
  }
  sessionStorage.setItem("role", roleValue);

  // user profile object as JSON
  sessionStorage.setItem(
    "user",
    JSON.stringify({
      userId,
      userName,
      emailId,
      phoneNumber,
      profilePicture,
    })
  );

  // branches: staff can belong to multiple branches now
  const branchList = Array.isArray(branches) ? branches : [];
  sessionStorage.setItem("branches", JSON.stringify(branchList));

  // derive a single branchId / branchName for backward compatibility:
  // - branchId: first branch (used as default selection / share links)
  // - branchName: all branch names joined (used for display)
  const primaryBranchId = branchList.length > 0 ? branchList[0].branchId : branchId;
  const primaryBranchName =
    branchList.length > 0
      ? branchList.map((b) => b.branchName).join(", ")
      : branchName;

  if (primaryBranchId !== undefined && primaryBranchId !== null) {
    sessionStorage.setItem("branchId", String(primaryBranchId));
  }
  if (primaryBranchName) sessionStorage.setItem("branchName", primaryBranchName);

  sessionStorage.setItem("gradeAccess", JSON.stringify(gradeAccess || []));
  sessionStorage.setItem("permissions", JSON.stringify(permissions || []));
};

// Branches stored at login as [{ branchId, branchName }]
export const getStoredBranches = () => {
  try {
    return JSON.parse(sessionStorage.getItem("branches") || "[]") || [];
  } catch {
    return [];
  }
};

// Branch options for SelectInput: [{ label, value }]
export const getStoredBranchOptions = () =>
  getStoredBranches().map((b) => ({ label: b.branchName, value: b.branchId }));
